function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(t, e) { if (e && ("object" == _typeof(e) || "function" == typeof e)) return e; if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined"); return _assertThisInitialized(t); }
function _assertThisInitialized(e) { if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); return e; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _getPrototypeOf(t) { return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) { return t.__proto__ || Object.getPrototypeOf(t); }, _getPrototypeOf(t); }
function _inherits(t, e) { if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function"); t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && _setPrototypeOf(t, e); }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import CheckUtils from '../utilities/check-utils';

/**
 * @memberOf module:wdh-feature-b2b
 */
var TextInput = /*#__PURE__*/function (_React$Component) {
  function TextInput(props) {
    var _this;
    _classCallCheck(this, TextInput);
    _this = _callSuper(this, TextInput, [props]);
    _this.state = {
      hasError: _this.props.hasError,
      hasValue: !CheckUtils.isNullOrEmptyString(_this.props.inputValue),
      display: _this.props.display
    };
    return _this;
  }

  /**
  * The component properties were received and component state will be synced with the change
  * @param {Object} nextProps The updated properties of the component
  */
  _inherits(TextInput, _React$Component);
  return _createClass(TextInput, [{
    key: "componentWillReceiveProps",
    value: function componentWillReceiveProps(nextProps) {
      if (nextProps.display !== this.props.display) {
        this.setState({
          display: nextProps.display
        });
      }
      if (nextProps.hasError !== this.props.hasError) {
        this.setState({
          hasError: nextProps.hasError
        });
      }
      if (nextProps.inputValue !== this.props.inputValue) {
        this.setState({
          hasValue: !CheckUtils.isNullOrEmptyString(nextProps.inputValue)
        });
      }
    }
  }, {
    key: "onChange",
    value: function onChange(e) {
      if (this.props.onValueChange) {
        // eslint-disable-line react/prop-types
        this.props.onValueChange(e);
      }
      if (this.props.maxValue) {
        if (e.currentTarget.value >= this.props.maxValue) {
          e.currentTarget.value = this.props.maxValue;
        }
      }
      return true;
    }
  }, {
    key: "onBlur",
    value: function onBlur(e) {
      var input = e.currentTarget;
      this.setState({
        hasValue: !CheckUtils.isNullOrEmptyString(input.value)
      });
      if (this.props.onBlur) {
        // eslint-disable-line react/prop-types
        this.props.onBlur(e);
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;
      var inputClasses = classNames({
        'has-value': this.state.hasValue,
        'has-error': this.state.hasError
      });
      /* eslint-disable jsx-a11y/label-has-for */
      return /*#__PURE__*/React.createElement("div", {
        className: "wdh-feature-b2b-field form-field has-float-label text-input",
        style: {
          display: this.state.display ? 'inline-block' : 'none'
        }
      }, /*#__PURE__*/React.createElement("input", {
        type: this.props.type,
        placeholder: " ",
        value: !CheckUtils.isNullOrEmptyString(this.props.inputValue) ? this.props.inputValue : '',
        className: inputClasses,
        onChange: function onChange(event) {
          return _this2.onChange(event);
        },
        id: this.props.id,
        name: this.props.name,
        onBlur: function onBlur(event) {
          return _this2.onBlur(event);
        },
        min: this.props.minValue,
        max: this.props.maxValue,
        autoComplete: this.props.autoComplete,
        disabled: this.props.disabled
      }), /*#__PURE__*/React.createElement("label", {
        htmlFor: this.props.id
      }, this.props.label, this.props.isRequired && /*#__PURE__*/React.createElement("span", {
        className: "required"
      }, "*")), /*#__PURE__*/React.createElement("div", {
        className: "help-text ".concat(this.props.showHelpText ? 'is-visible' : ''),
        dangerouslySetInnerHTML: {
          __html: this.props.helpTextHTML
        },
        style: {
          visibility: this.props.showHelpText ? 'visible' : 'hidden'
        }
      }));
    }
  }]);
}(React.Component);
TextInput.propTypes = {
  onValueChange: PropTypes.func.isRequired,
  inputValue: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  label: PropTypes.string,
  id: PropTypes.string,
  name: PropTypes.string.isRequired,
  type: PropTypes.string,
  display: PropTypes.bool,
  showHelpText: PropTypes.bool,
  helpTextHTML: PropTypes.string,
  hasError: PropTypes.bool,
  isRequired: PropTypes.bool,
  autoComplete: PropTypes.string,
  disabled: PropTypes.bool
};
TextInput.defaultProps = {
  inputValue: '',
  label: '',
  id: '',
  type: 'text',
  display: true,
  showHelpText: false,
  helpTextHTML: '&nbsp;',
  hasError: false,
  isRequired: false,
  autoComplete: '',
  disabled: false
};
export default TextInput;